import React from 'react';
import LinksList from '../../../../../components_v2/desktop/LinksList/LinksList';
import { TOI_LIVE_DOMAIN } from '../../../../../constants';
import s from './RelatedCelebs.scss';

const RelatedCelebs = ({ cards, isWapView, page }) => {
  if (!cards || !cards.length) {
    return null;
  }

  const formatCards = () =>
    cards.map(el => ({
      hl: el.name,
      wu: `${TOI_LIVE_DOMAIN}/topic${el.linkUrl}${
        page === 'photos' ? '/photos' : ''
      }`,
    }));

  return (
    <div className={s.releated_box}>
      {isWapView ? (
        <>
          <h2>Related Celebs</h2>
          <div className={s.releated_list}>
            {Array.isArray(cards) &&
              !!cards.length &&
              cards.map((el, idx) => (
                <div
                  onClick={() =>
                    window.open(
                      `${el.linkUrl}${page === 'photos' ? '/photos' : ''}`,
                    )
                  }
                  className={s.list}
                  key={idx}
                >
                  {el.name}
                </div>
              ))}
          </div>
        </>
      ) : (
        <LinksList
          sectionData={{ data: formatCards(), name: 'Related Celebs' }}
        />
      )}
    </div>
  );
};

export default RelatedCelebs;
